import { render, staticRenderFns } from "./Indicators.vue?vue&type=template&id=4f51e23c&scoped=true&"
import script from "./Indicators.vue?vue&type=script&lang=js&"
export * from "./Indicators.vue?vue&type=script&lang=js&"
import style0 from "./Indicators.vue?vue&type=style&index=0&id=4f51e23c&prod&scoped=true&lang=css&"
import style1 from "./Indicators.vue?vue&type=style&index=1&id=4f51e23c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f51e23c",
  null
  
)

export default component.exports